import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Topnav = ({ toggleSidebar }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('token') === null) {
            navigate('/');
        } else {
            const storedAuthor = localStorage.getItem('author');
            if (storedAuthor) {
                const author = JSON.parse(storedAuthor);
                setName(author.name || '');
                setEmail(author.email || '');
                setIsAdmin(author.is_admin === 1);
            }
        }
    }, []);

    return (
        <>
            <div className="main-header">
                <div className="main-header-logo">
                    <div className="logo-header" data-background-color="dark">
                        <a href="/dashboard" className="logo">
                            <h1 style={{ color: '#60a5fa' }}>E-books</h1>
                        </a>
                        <div className="nav-toggle">
                            <button className="btn btn-toggle toggle-sidebar">
                                <i className="gg-menu-right"></i>
                            </button>
                            <button className="btn btn-toggle sidenav-toggler" onClick={toggleSidebar}>
                                <i className="gg-menu-left"></i>
                            </button>
                        </div>
                        <button className="topbar-toggler more">
                            <i className="gg-more-vertical-alt"></i>
                        </button>
                    </div>
                </div>
                <nav className="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom">
                    <div className="container-fluid">
                        <nav className="navbar navbar-header-left navbar-expand-lg navbar-form nav-search p-0 d-none d-lg-flex">
                            <div>
                                <h2>{isAdmin ? 'Admin Dashboard' : 'Author Dashboard'}</h2>
                            </div>
                        </nav>

                        <ul className="navbar-nav topbar-nav ms-md-auto align-items-center">
                            <li className="nav-item topbar-user dropdown hidden-caret">
                                <a
                                    className="dropdown-toggle profile-pic"
                                    data-bs-toggle="dropdown"
                                    href="0"
                                    aria-expanded="false"
                                >
                                    <div className="avatar-sm">
                                        <img
                                            src="../assets/img/avator.PNG"
                                            alt="User profile"
                                            className="avatar-img rounded-circle"
                                        />
                                    </div>
                                    <span className="profile-username">
                                        <span className="op-7" style={{ float: 'left' }}>
                                            {name} {isAdmin && <span className="badge bg-primary" style={{ fontSize: '10px', marginLeft: '5px' }}>Admin</span>}
                                        </span>
                                        <br />
                                        <span className="fw-bold">{email}</span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </>
    );
};

export default Topnav;